import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import './InspectorExpertReview.scss';
import { BsCheckLg } from 'react-icons/bs';
import { IoMdRepeat } from 'react-icons/io';
import { ImCross } from 'react-icons/im';
import { useState, useContext } from 'react';

import { postActionsInspector } from '../../services/certificationsMaster';
import { apiCertificationsApp } from '../../resources/environmentConstants';
import { getUrlWithSessionCreds } from '../../utils/globalFunctions';
import LoaderContext from '../../context/LoaderProvider';
import useToast from '../../hooks/useToast';

const actions = {
  REVALIDAR: 'Revalidar',
  RECHAZAR: 'Rechazar',
  AUTORIZAR: 'Autorizar'
};

const ErrorComments = ({
  errorMessages,
  disableButton,
  setResponseText,
  setFieldValue,
  value,
  setErrorMessages
}) => {
  const [warningText, setWarningText] = useState('');
  const [activeWarning, setActiveWarning] = useState(false);
  const [isUserWarned, setIsUserWarned] = useState(false);

  const { setLoader } = useContext(LoaderContext);
  const { setNewToast } = useToast();

  const onSubmitAction = async ({ action, idError }) => {
    try {
      setLoader(true);
      const resp = await postActionsInspector({ action, errorId: idError });

      if (action === actions.AUTORIZAR) {
        /* Existen 4 posibles respuestas para la accion autorizar,
        "El PT ha sido autorizado correctamente";
        "No se pudo completar esta acción porque ha cambiado su estado a: {estado}"
        "No se pudo realizar la acción"
        "". un string vacio cuando se autoriza y quedan péndientes para autorizar
        Cuando recibo un string vacio, lo elimino de la lista sin hacer una nueva consulta porque ya se que se autorizo */
        if (!resp.message) {
          const newErrorMessages = errorMessages.filter((error) => error.idError !== idError);

          setErrorMessages(newErrorMessages);
        } else {
          setResponseText({ message: resp.message, active: true });
        }
      } else {
        setResponseText({ message: resp.message, active: true });
      }

      setActiveWarning(false);
      setWarningText('');
      setLoader(false);
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const getDescripcion = (descripcionControl, mensajeError) => {
    if (descripcionControl && !mensajeError) {
      return <strong>{descripcionControl}</strong>;
    }

    if (descripcionControl && mensajeError) {
      return (
        <>
          <strong>{descripcionControl}:</strong> <span>{mensajeError}</span>
        </>
      );
    }

    if (mensajeError) {
      return <span>{mensajeError}</span>;
    }

    return null;
  };

  const handleActionAndFetch = (action, idError) => {
    setFieldValue('action', action);
    if (action === actions.AUTORIZAR) {
      if (errorMessages.length === 1 && !isUserWarned) {
        setIsUserWarned(true);
        setActiveWarning(true);

        setWarningText(
          'La cantidad notificada quedará autorizada y no será posible rectificarla. ¿Desea autorizar este PT?'
        );

        return;
      }
    } else if (action === actions.RECHAZAR) {
      if (!isUserWarned) {
        setIsUserWarned(true);
        setActiveWarning(true);
        setWarningText(
          'Esta acción anula de forma definitiva la certificación de este concepto. ¿Desea rechazar este PT?'
        );
      }

      return;
    }
    onSubmitAction({ action, idError });
  };

  return errorMessages?.map(({ descripcionControl, mensajeError, fechaHora, idError, pozo }, i) => (
    <li className="container_comments" key={`${fechaHora} + ${i.toString()}`}>
      <div className="title_comments">
        <p>Sistema Experto</p>
        <span className="date_division">-</span>
        <p className="date_time">{dayjs(fechaHora).format('DD/MM/YYYY')}</p>
        <span className="date_division">|</span>
        <p className="date_time">{dayjs(fechaHora).format('HH:mm:ss')}</p>
        {pozo && (
          <>
            <span className="date_division">|</span>
            <p className="well_name">{pozo}</p>
          </>
        )}
      </div>
      <div className="error_comments">{getDescripcion(descripcionControl, mensajeError)}</div>
      <hr className="my-2" />
      <div className="flex actions">
        <button
          className={`text-${disableButton ? 'secondary cursor-disabled' : 'success'}`}
          disabled={disableButton}
          onClick={() => handleActionAndFetch(actions.AUTORIZAR, idError)}
          type="button"
        >
          <BsCheckLg size={12} /> Autorizar
        </button>
        <button
          className={`text-${disableButton ? 'secondary cursor-disabled' : 'danger'}`}
          disabled={disableButton}
          onClick={() => handleActionAndFetch(actions.RECHAZAR, idError)}
          type="button"
        >
          <ImCross size={11} /> Rechazar
        </button>
        <button
          className={`text-${disableButton ? 'secondary cursor-disabled' : 'warning'}`}
          disabled={disableButton}
          onClick={() => handleActionAndFetch(actions.REVALIDAR, idError)}
          type="button"
        >
          <IoMdRepeat size={14} /> Revalidar
        </button>
        <a
          className={`text-${disableButton ? 'secondary cursor-disabled' : 'primary'}`}
          disabled={disableButton}
          href={getUrlWithSessionCreds(
            `${apiCertificationsApp}/#/inspeccion/partes/detalle/${idError}`
          )}
          rel="noreferrer"
          target="_blank"
        >
          Ver detalle
        </a>
      </div>
      <div
        className={`bg-danger mt-2 p-2 rounded text-white ${
          activeWarning === true ? 'd-block' : 'd-none'
        }`}
      >
        {warningText}
        <button
          className="bg-transparent px-3 mx-2 rounded border border-white text-white"
          onClick={() => onSubmitAction({ idError, action: value })}
          type="button"
        >
          Sí, {value}
        </button>
        <button
          className="bg-transparent px-2 mx-2 rounded border border-white text-white"
          onClick={() => {
            setActiveWarning(false);
            setIsUserWarned(false);
          }}
          type="button"
        >
          No
        </button>
      </div>
    </li>
  ));
};

ErrorComments.propTypes = {
  errorMessages: PropTypes.arrayOf(
    PropTypes.shape({
      descripcionControl: PropTypes.string,
      fechaHora: PropTypes.string,
      mensajeError: PropTypes.string,
      idError: PropTypes.number,
      pozo: PropTypes.string
    })
  ),
  disableButton: PropTypes.bool,
  setResponseText: PropTypes.func,
  setFieldValue: PropTypes.func,
  value: PropTypes.string
};

ErrorComments.defaultProps = {
  errorMessages: [
    {
      descripcionControl: '',
      fechaHora: '',
      mensajeError: '',
      idError: 0,
      pozo: ''
    }
  ],
  disableButton: false,
  setResponseText: () => {
    /* Empty */
  },
  setFieldValue: () => {
    /* Empty */
  },
  value: ''
};

export default ErrorComments;
